<template>
  <div class="bg-white">
    <!--statistic-->
    <div class="statistic">
      <div class="row">
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'search-npa', query: currentYearProjectQuery })">
              <p><strong>{{ statistics.all_npas }}</strong>{{ $t("проектов всего") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'search-npa', query: getCurrentYearProjectQuery(3) })">
              <p><strong>{{ statistics.in_discuss }}</strong>{{ $t("проектов на обсуждении") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'search-npa', query: getCurrentYearProjectQuery(5) })">
              <p><strong>{{ statistics.discuss_close }}</strong>{{ $t("проектов завершено") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'search-npa', query: getCurrentYearProjectQuery(6) })">
              <p><strong>{{ statistics.adopted }}</strong>{{ $t("принятые проекты") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <p><strong>{{ statistics.comments_public }}</strong>{{ $t("комментариев") }}</p>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'comment-statistics', params: { id: 1 }, query: currentYearCommentQuery })">
              <p><strong>{{ statistics.comments_with_ans }}</strong>{{ $t("комментариев учтено") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <p><strong>{{ statistics.users }}</strong>{{ $t("пользователей") }}<br/>
              {{ $t("в регистрации") }}</p>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'comment-statistics', params: { id: 2 }, query: currentYearCommentQuery })">
              <p><strong>{{ statistics.comments_without_ans }}</strong>{{ $t("не отвеченных комментариев") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'comment-statistics', params: { id: 3 }, query: currentYearCommentQuery })">
              <p><strong>{{ statistics.answers }}</strong>{{ $t("количество ответов") }}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--diagram-->
    <div class="diagram portal-statistics-diagram">
      <div class="row portal-statistics-charts">
        <div class="col l6 m12 s12">
          <div class="portal-statistics-card">
            <h4>{{ $t("Проекты НПА по годам") }}</h4>
            <p class="portal-statistics-note">
              {{ $t('Динамика размещения проектов по годам') }}
            </p>
            <div class="diagram-developer">
              <apexcharts height="420" type="bar" :options="yearOptions" :series="yearData"></apexcharts>
            </div>
          </div>
        </div>
        <div class="col l6 m12 s12">
          <div class="portal-statistics-card">
            <h4>{{ $t("По видам НПА") }}</h4>
            <p class="portal-statistics-note">
              {{ $t('Распределение проектов по виду нормативного акта') }}
            </p>
            <div class="diagram-kind">
              <apexcharts height="600" type="donut" :options="kindNpaOptions" :series="kindNpaData"></apexcharts>
            </div>
          </div>
        </div>
<!--        <div class="col l4 m12">-->
<!--          <h4>{{ $t("По активности портала") }}</h4>-->
<!--          <div class="diagram-activity">-->
<!--            <apexcharts type="line" :options="activityOptions" :series="activityData"></apexcharts>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <div class="portal-statistics-action">
      <router-link
        class="btn btn-default portal-statistics-link text-white"
        :to="$i18nRoute({ name: 'NpaStatistics' })"
      >
        {{ $t('Посмотреть статистику проектов НПА') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import NPA from '@/model/npa'

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {
      statistics: [],
      // Проекты НПА по годам
      yearData: [{
        data: []
      }],
      yearOptions: {
        chart: {
          type: 'bar',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 3,
            columnWidth: '55%',
            distributed: true
          }
        },
        colors: ['#145aa0', '#2f80d8', '#67b7ff', '#9ee0f2', '#e5a75d', '#8fa3b7'],
        legend: {
          show: false
        },
        dataLabels: {
          enabled: true,
          formatter: function (value) {
            return value
          },
          style: {
            colors: ['#17324d'],
            fontSize: '12px',
            fontWeight: 600
          },
          background: {
            enabled: false
          }
        },
        grid: {
          borderColor: '#d9e3ee',
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: false
            }
          }
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: '#52677c',
              fontSize: '12px'
            }
          }
        },
        yaxis: {
          labels: {
            show: true,
            style: {
              colors: '#17324d',
              fontSize: '12px'
            }
          }
        },
        tooltip: {
          theme: 'light',
          x: {
            show: true
          },
          y: {
            title: {
              formatter: function () {
                return ''
              }
            }
          },
        }
      },
      //По видам НПА
      kindNpaData: [],
      kindNpaOptions: {
        chart: {
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          pie: {
            startAngle: 0,
            donut: {
              size: '50%',
              labels: {
                show: true,
                name: {
                  show: true,
                  color: '#52677c',
                  fontSize: '12px'
                },
                value: {
                  show: true,
                  color: '#0b3f78',
                  fontSize: '26px',
                  fontWeight: 700
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: this.$t('проектов всего'),
                  color: '#52677c',
                  fontSize: '12px'
                }
              }
            }
          }
        },
        colors: ['#0b3f78', '#145aa0', '#2f80d8', '#9ee0f2', '#e5a75d', '#8fa3b7', '#009CDE', '#92EBFE', '#FF6D6D', '#00B5AD'],
        legend: {
          show: true,
          position: 'bottom',
          fontSize: '11px',
          markers: {
            width: 10,
            height: 10
          },
          itemMargin: {
            horizontal: 8,
            vertical: 4
          },
        },
        labels: [],
        dataLabels: {
          style: {
            colors: ['#fff'],
            fontSize: '12px',
            fontWeight: 700
          },
          dropShadow: {
            enabled: true
          }
        }
      },
      //По активности портала
      activityData: [
        {
          name: 'Январь',
          data: [500, 1000, 2500]
        }
      ],
      activityOptions: {
        chart: {
          type: 'line',
          horizontal: true,
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: true
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: ['I', 'II', 'III']
        },
        labels: [
          'Январь',
          'Февраль',
          'Март'
        ],
      }
    }
  },
  computed: {
    currentYearProjectQuery() {
      const year = this.statistics.year
      if (!year) {
        return {}
      }

      return {
        publishDateFrom: `${year}-01-01`,
        publishDateTo: `${year}-12-31`
      }
    },
    currentYearCommentQuery() {
      const year = this.statistics.year
      if (!year) {
        return {}
      }

      return {
        year: String(year)
      }
    }
  },
  mounted() {
    NPA.getPortalStatistics()
      .then((response) => {
        this.statistics = response.data
        this.updateChartNpaKind()
      })
      .catch((error) => {
        //@todo ошибки
      })

    this.loadProjectYearsStatistics()
  },
  methods: {
    getCurrentYearProjectQuery(status = null) {
      const query = {
        ...this.currentYearProjectQuery
      }

      if (status !== null) {
        query.status = status
      }

      return query
    },
    async loadProjectYearsStatistics() {
      try {
        const response = await this.$http.get(`${this.$i18n.locale}/api/statistics/projects_by_years`)
        const chart = response.data && response.data.success ? response.data.chart : null
        if (!chart || !chart.data) {
          return
        }

        const labels = chart.data.labels || []
        const values = chart.data.datasets && chart.data.datasets[0] ? chart.data.datasets[0].data : []

        this.yearData = [{
          name: this.$t('Проекты'),
          data: values
        }]
        this.yearOptions = {
          ...this.yearOptions,
          xaxis: {
            ...this.yearOptions.xaxis,
            categories: labels
          }
        }
      } catch (error) {
        //@todo ошибки
      }
    },
    //По видам НПА
    updateChartNpaKind() {
      const resName = this.statistics.viewNpas.map(item => item.transName)
      const resCount = this.statistics.viewNpas.map(item => item.cnt)
      this.kindNpaData = resCount
      this.kindNpaOptions = {
        ...this.kindNpaOptions,
        labels: resName,
        plotOptions: {
          ...this.kindNpaOptions.plotOptions,
          pie: {
            ...this.kindNpaOptions.plotOptions.pie,
            donut: {
              ...this.kindNpaOptions.plotOptions.pie.donut,
              labels: {
                ...this.kindNpaOptions.plotOptions.pie.donut.labels,
                total: {
                  ...this.kindNpaOptions.plotOptions.pie.donut.labels.total,
                  formatter: () => String(this.statistics.all_npas || resCount.reduce((sum, count) => sum + Number(count || 0), 0))
                }
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.portal-statistics-action {
  display: flex;
  justify-content: center;
  padding: 20px 15px 0;
}

.portal-statistics-link {
  height: auto;
  min-height: 50px;
  line-height: 1.3;
  max-width: 100%;
  padding: 14px 24px;
  white-space: normal;
}

.portal-statistics-diagram {
  padding: 0;
}

.portal-statistics-charts {
  align-items: stretch;
  margin: 0 -10px;
}

.portal-statistics-charts > .col {
  display: flex;
  padding: 0 10px;
}

.portal-statistics-card {
  background: #fff;
  border: 1px solid #d8e2ec;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(20, 68, 109, .12);
  display: flex;
  flex-direction: column;
  min-height: 420px;
  padding: 22px 22px 16px;
  width: 100%;
}

.portal-statistics-card h4 {
  color: #003f79;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.25;
  margin: 0 0 4px;
}

.portal-statistics-note {
  color: #52677c;
  font-size: 12px;
  line-height: 1.35;
  margin: 0 0 16px;
}

.diagram-developer,
.diagram-kind {
  flex: 1 1 auto;
  min-width: 0;
}

@media (max-width: 600px) {
  .portal-statistics-card {
    padding: 18px 14px 12px;
  }
}

.text-white {
  color: white!important;
}
</style>
